import styled from '@emotion/styled';
import {
  breakpoints,
  colors,
  fonts,
  media,
  pxToCssFont,
  pxToCssFontSize,
  pxToRem,
  theme,
} from '@vfit/shared/themes';

export const ShoppingCartOfferContainer = styled.div`
  margin-top: 48px;

  h3 {
    font-family: ${fonts.exbold};
    font-weight: 400;
    ${pxToCssFontSize(20)}
    margin-top: 0;
    margin-bottom: 0;
  }

  h4 {
    font-family: ${fonts.light};
    font-weight: 400;
    ${pxToCssFontSize(20)}
    margin-top: 14px;
    margin-bottom: 0;
  }

  #edit-address {
    text-decoration-line: underline;
    text-underline-position: from-font;
    width: max-content;

    &:hover {
      color: ${colors.$e60000};
    }

    &:active {
      color: ${colors.$e60000};
    }
  }

  p {
    font-family: ${fonts.regular};
    font-weight: 700;
    ${pxToCssFont(18, 26)}
    color: ${colors.$262626};
    margin: 0;
    margin-top: 16px;
    cursor: pointer;
  }

  @media (min-width: ${breakpoints.tablet}) {
    margin-left: 32px;
    margin-right: 32px;

    h3 {
      ${pxToCssFontSize(30)}
    }

    h4 {
      ${pxToCssFontSize(24)}
    }

    p {
      ${pxToCssFontSize(18)}
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-left: 80px;
    margin-right: 80px;

    h3 {
      ${pxToCssFont(36, 38)}
    }

    h4 {
      ${pxToCssFontSize(24)}
    }

    p {
      ${pxToCssFontSize(18)}
    }
  }
`;

export const ConsumerTopShoppingCartContainer = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: clip;
  display: flex;
  flex-direction: column;

  ${media.largeDesktop`
    margin-top: ${pxToRem(60)};
    padding-left: ${pxToRem(94.5)};
    padding-right: ${pxToRem(94.5)};
  `}
`;

export const MapAddressCard = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${pxToRem(32)};

  ${media.largeDesktop`
    width: ${pxToRem(560)};
    flex: 0 0 auto;
  `}
`;

export const OfferDetailsCard = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;

  ${media.largeDesktop`
    flex: 1 1 0;
    min-width: 0;
  `}
`;

export const FixedLineCard = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: ${theme.colors.bg.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(32)};
  padding: ${pxToRem(32)} ${pxToRem(32)};

  ${media.tablet`
      padding: ${theme.spacing.xl} ${pxToRem(40)};
  `}

  ${media.largeDesktop`
      flex-direction: row;
      align-items: center;
      gap: ${pxToRem(40)};
      align-self: center;
      width: 100%;
      max-width: ${pxToRem(1280)};
      margin: ${pxToRem(60)} auto;
      padding: ${theme.spacing.xl} ${pxToRem(60)};
  `}
`;

